import { render, staticRenderFns } from "./SortableTableHeader.vue?vue&type=template&id=a79f54fc&scoped=true"
import script from "./SortableTableHeader.vue?vue&type=script&lang=js"
export * from "./SortableTableHeader.vue?vue&type=script&lang=js"
import style0 from "./SortableTableHeader.vue?vue&type=style&index=0&id=a79f54fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a79f54fc",
  null
  
)

export default component.exports